export default __webpack_public_path__ + "static/pipes-e57cf7fc44188f22b88fd03588c92c78.jpg";